<template>
  <div class="progress">
    <p>{{ prefixText }}</p>
    <div class="progress-bar">
      <div
        v-if="percent === 100"
        class="progress-point progress-point--active"
        :style="{ left: '100%', transform: 'translate(-100%,-50%)' }"
      >
        <v-icon class="icon--primary">mdi-check</v-icon>
      </div>
      <div
        v-else
        class="progress-point progress-point--active"
        :style="{
          left: `${percent}%`,
          transform: `translate(-${percent}%,-50%)`,
        }"
      >
        {{ percent }}%
      </div>
      <div
        class="progress-step progress-step-min"
        :class="{ 'progress-step--active': percent >= 25 }"
      ></div>
      <div
        class="progress-step"
        :class="{ 'progress-step--active': percent >= 50 }"
      ></div>
      <div
        class="progress-step"
        :class="{ 'progress-step--active': percent >= 75 }"
      ></div>
      <div
        class="progress-step progress-step-max"
        :class="{ 'progress-step--active': percent >= 100 }"
      ></div>
      <div class="progress-point progress-point--max">
        <v-icon color="orange">mdi-check</v-icon>
      </div>
    </div>
    <p>{{ suffixText }}</p>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    percent: {
      default: 0,
      type: Number,
    },
    prefixText: {
      default: "",
      type: String,
    },
    suffixText: {
      default: "",
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.progress {
  display: flex;
  align-items: baseline;
  gap: 24px;
}

.progress > p {
  font-family: "prompt", sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}

.progress-bar {
  display: flex;
  position: relative;
}

.progress-point {
  position: absolute;
  border-radius: 16px;
  height: 28px;
  width: 28px;
  border: 4px solid #ffc166;
  background-color: #fff;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "sarabun", sans-serif;
  font-size: 10px;
  color: var(--color-gray);
  transform: translateY(-50%);
  top: 50%;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}

.progress-point--active {
  border: 4px solid #ff9800;
  z-index: 2;
}

.progress-point--max {
  right: 0;
}

.progress-step {
  box-sizing: border-box;
  height: 8px;
  width: 120px;
  background-color: #ffc166;
  border-left: 0.5px solid #fff;
  border-right: 0.5px solid #fff;
}

.progress-step--active {
  background-color: #ff9800;
}

.progress-step-min {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-left-color: #ffc166;
}

.progress-step-max {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right-color: #ffc166;
}
</style>
